import type { SVGProps } from "react";
export interface UserSettingsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function UserSettingsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: UserSettingsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.392 11.875c.886 0 1.604.71 1.621 1.594a1.625 1.625 0 0 1 2.104.469l.09.14.703 1.219.077.148a1.624 1.624 0 0 1-.645 2.055c.71.427.979 1.313.645 2.055l-.076.148-.704 1.219a1.624 1.624 0 0 1-2.194.608 1.623 1.623 0 0 1-1.622 1.595h-1.409a1.624 1.624 0 0 1-1.623-1.595c-.724.4-1.626.192-2.102-.468l-.09-.14-.704-1.219a1.623 1.623 0 0 1 .57-2.203 1.623 1.623 0 0 1-.57-2.203l.703-1.219.091-.14a1.625 1.625 0 0 1 2.102-.47 1.624 1.624 0 0 1 1.623-1.593zm-.544 4.058a1.576 1.576 0 1 1-1.729 1.728l-.007-.161.008-.161a1.575 1.575 0 0 1 1.567-1.414zm-2.408 1.696a1.68 1.68 0 0 1-.72 1.482l.085.151a1.67 1.67 0 0 1 1.461.013l.188.107.22.13c.475.239.878.728.925 1.363h.176c.047-.635.45-1.124.924-1.364l.221-.129.188-.107a1.67 1.67 0 0 1 1.459-.013l.086-.15a1.68 1.68 0 0 1-.719-1.483l.004-.129-.004-.129a1.68 1.68 0 0 1 .72-1.484l-.087-.15a1.68 1.68 0 0 1-1.647-.12 2 2 0 0 0-.22-.128 1.68 1.68 0 0 1-.925-1.364h-.176a1.68 1.68 0 0 1-.924 1.364q-.115.058-.222.129a1.68 1.68 0 0 1-1.647.118l-.087.151c.527.358.75.953.72 1.484a2 2 0 0 0 0 .258Zm-5.959-3.754.114.006a1.125 1.125 0 0 1 0 2.238l-.114.006H7.143a4.014 4.014 0 0 0-4.005 3.75h6.73l.114.006a1.125 1.125 0 0 1 0 2.238l-.114.006H2.857a1.98 1.98 0 0 1-1.982-1.982 6.27 6.27 0 0 1 6.268-6.268zm3.645-6.625a3.126 3.126 0 1 0-6.252.002 3.126 3.126 0 0 0 6.252-.002m2.25 0a5.376 5.376 0 1 1-10.75 0 5.376 5.376 0 0 1 10.75 0"
      />
    </svg>
  );
}
